"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var ButtonWithArrow_1 = require("../../../../common/components/presentation/Buttons/ButtonWithArrow");
var DefaultButton_1 = require("../../../../common/components/presentation/Buttons/DefaultButton");
var Translation_1 = require("../../../../common/components/presentation/Translation/Translation");
var reconfigureButtonStyles_1 = require("./reconfigureButtonStyles");
var ReconfigureButton = function (_a) {
    var changeConfiguration = _a.changeConfiguration;
    var _b, _c;
    var styles = reconfigureButtonStyles_1.default();
    var _d = core_1.useTheme().checkoutLite, isFromAltSpc = _d.isFromAltSpc, summary = _d.summary;
    if (isFromAltSpc) {
        return (<core_1.Box justifyContent="center" display="flex" className={styles.buttonContainer}>
        <DefaultButton_1.default labelClasses={styles.btnLabel} className={[styles.reconfigureBtn]} variant="outlined" dataTest="summary:button:change_configuration" onClick={changeConfiguration}>
          <Translation_1.default id={'carDetails.label.modifyCar'}/>
        </DefaultButton_1.default>
      </core_1.Box>);
    }
    return (<core_1.Box justifyContent="center" display="flex" padding="20px 0 20px 0">
      <ButtonWithArrow_1.default iconClasses={((_b = summary) === null || _b === void 0 ? void 0 : _b.hideButtonIcon) ? styles.buttonHideIcon : ''} className={((_c = summary) === null || _c === void 0 ? void 0 : _c.hideButtonIcon) ? styles.buttonNoRadius : ''} data-test="summary:button:change_configuration" onClick={changeConfiguration}>
        <core_1.Typography component="span">
          <Translation_1.default id={'carDetails.label.modifyCar'}/>
        </core_1.Typography>
      </ButtonWithArrow_1.default>
    </core_1.Box>);
};
exports.default = ReconfigureButton;
